import React from 'react'

import type { ShipmentListItem, TabStatus } from '../type'
import styles from './ShipmentItem.module.css'

type Props = {
  shipment: ShipmentListItem
  activeTab: TabStatus
  onClick: () => void
}

export const ShipmentItem: React.FC<Props> = ({ shipment, activeTab, onClick }) => {
  const dateLabel = activeTab === 'active' ? '登録日時' : '完了日時'
  const dateValue = activeTab === 'active' ? shipment.registeredAt : shipment.completedAt

  return (
    <button className={styles.item} onClick={onClick}>
      <div className={styles.content}>
        <div className={styles.row}>
          <span className={styles.label}>{dateLabel}</span>
          <span className={styles.value}>{dateValue}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.label}>納品先</span>
          <span className={styles.value}>{shipment.deliveryDestinationName ?? '—'}</span>
        </div>
      </div>
      <span className={styles.chevron}>›</span>
    </button>
  )
}
